// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-view-container[data-v-52d83976] {\n  font-family: \"Poppins\";\n  display: grid;\n  grid-template-columns: auto 376px;\n  width: 100%;\n  height: 100vh;\n  color: #151515;\n  background-color: #f7f8f7;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
